import { render, staticRenderFns } from "./VistaQR.vue?vue&type=template&id=89f6d662&"
import script from "./VistaQR.vue?vue&type=script&lang=ts&"
export * from "./VistaQR.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports